var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "img",
    _vm._g(
      _vm._b(
        { attrs: { src: _vm.currentSrc }, on: { error: _vm.onError } },
        "img",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }